const styles = theme => ({
  coverImageThumb : theme.coverImageThumb
});

export default styles;